/** The kind and status chips the list and the report drawer share (SA-1305). */
import { Badge } from '@/components/ui'
import type { AssessmentKind, ReportStatus } from '@/services/helpFeedback/appFeedbackApi'
import * as T from './feedbackAdminText'

export function KindChip({ kind }: { kind: AssessmentKind | null }) {
  if (!kind) return <span className="text-muted-foreground">{T.DASH}</span>
  return <Badge variant="neutral">{T.KIND_WORDS[kind] ?? kind}</Badge>
}

export function StatusChip({ status }: { status: ReportStatus }) {
  const words = T.STATUS_WORDS[status]
  return <Badge variant={words?.tone ?? 'neutral'}>{words?.label ?? status}</Badge>
}
